module.exports = __webpack_public_path__ + "static/media/Retaining_Customers-desktop.b7a68355.png";